import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { Observable } from 'rxjs';

export interface RequestTypeCount {
  typeId: number;
  count: number;
}

export interface RequestCounts {
  requestCountTotal: number;
  byType: RequestTypeCount[];
}

export interface TodayCounts {
  missedCalls?: number;
  unreadEmailThreads?: number;
  unknownUnreadEmailThreads?: number;
  unreadSmsThreads?: number;
  unreadUnknownSmsThreads?: number;
  unreadEmailCountForThread?: number;
  unreadSmsCountForThread?: number;
  requests?: RequestCounts;
}

@Injectable({
  providedIn: 'root'
})
export class TodayBadgeCountsService {

  baseUrl = '/today-badge-counts';

  /**
   * @param http - Injected http client service.
   */
  constructor(
    private http: ApiHttpClient
  ) {}

  getTodayBadgeCounts(
    lenderUserId: number,
  ): Observable<TodayCounts> {
    return this.http.get<TodayCounts>(`${this.baseUrl}/${lenderUserId}`);
  }

}
